<div class="view-container dashboard-page">
  <div class="mbp-page-header dashboard-page__header">
    <div class="mbp-page-header__icon">
      <mat-icon>dashboard</mat-icon>
    </div>
    <div>
      <h1 class="mbp-page-header__title">Dashboard</h1>
      <p class="mbp-page-header__subtitle">Hi, welcome to Magalies Pharmaceuticals</p>
    </div>
  </div>

  <div *authGroup="dashboardCardRoles" class="dashboard-page__grid row g-2">
    <div class="col-lg-6">
      <mat-card class="dashboard-section">
        <div class="dashboard-section__header">
          <h2 class="dashboard-section__title">Orders</h2>
          @if (perm.canMutateDashboard()) {
            <a routerLink="/portal/submit" mat-flat-button color="primary" class="dashboard-section__action">
              <mat-icon>add</mat-icon> New prescription
            </a>
          }
        </div>

        <form [formGroup]="ordersDateRangeForm" class="dashboard-section__filters">
          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__date-field" subscriptSizing="dynamic">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="ordersPicker">
              <input formControlName="start" matStartDate>
              <input formControlName="end" matEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="ordersPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #ordersPicker></mat-date-range-picker>
          </mat-form-field>
        </form>

        <core-statistics [data]="ordersData" [config]="ordersConfig" [heading]="'Orders'"></core-statistics>

        @if (perm.canMutateDashboard()) {
          <div class="dashboard-section__actions">
            <div class="dashboard-section__action-row">
            <mat-form-field appearance="outline" class="dashboard-section__select dashboard-section__select--action" subscriptSizing="dynamic">
              <mat-select
                id="dashboard-orders-report-type"
                placeholder="Report type"
                aria-label="Report type"
                [formControl]="downloadOrdersReportControl">
                <mat-option value="csv">CSV</mat-option>
                <mat-option value="excel">Excel</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              type="button"
              class="dashboard-section__btn"
              [disabled]="downloadOrdersReportControl.invalid || ordersDateRangeForm.invalid"
              mat-stroked-button
              (click)="generateAndDownloadOrders()">
              <mat-icon>file_download</mat-icon> Download
            </button>
            </div>
          </div>
        }
      </mat-card>
    </div>

    <div class="col-lg-6">
      <mat-card class="dashboard-section">
        <div class="dashboard-section__header">
          <h2 class="dashboard-section__title">Batches</h2>
          @if (perm.canMutateDashboard()) {
            <a routerLink="/portal/batches/create" mat-flat-button color="primary" class="dashboard-section__action">
              <mat-icon>add</mat-icon> New batch
            </a>
          }
        </div>

        <form [formGroup]="batchesDateRangeForm" class="dashboard-section__filters">
          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__date-field" subscriptSizing="dynamic">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="batchesPicker">
              <input formControlName="start" matStartDate>
              <input formControlName="end" matEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="batchesPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #batchesPicker></mat-date-range-picker>
          </mat-form-field>
        </form>

        <core-statistics [data]="batchesData" [config]="batchesConfig" [heading]="'Batches'"></core-statistics>

        @if (perm.canMutateDashboard()) {
          <div class="dashboard-section__actions">
            <div class="dashboard-section__action-row">
            <mat-form-field appearance="outline" class="dashboard-section__select dashboard-section__select--action" subscriptSizing="dynamic">
              <mat-select
                id="dashboard-batches-report-type"
                placeholder="Report type"
                aria-label="Report type"
                [formControl]="downloadBatchesReportControl">
                <mat-option value="csv">CSV</mat-option>
                <mat-option value="excel">Excel</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              type="button"
              class="dashboard-section__btn"
              mat-stroked-button
              [disabled]="downloadBatchesReportControl.invalid || batchesDateRangeForm.invalid"
              (click)="generateAndDownloadBatches()">
              <mat-icon>file_download</mat-icon> Download
            </button>
            </div>
          </div>
        }
      </mat-card>
    </div>

    <div class="col-12">
      <mat-card class="dashboard-section">
        <div class="dashboard-section__header">
          <h2 class="dashboard-section__title">Medicine</h2>
          @if (perm.canMutateDashboard()) {
            <a routerLink="/portal/medicine/create" mat-flat-button color="primary" class="dashboard-section__action">
              <mat-icon>add</mat-icon> New medicine
            </a>
          }
        </div>

        <form [formGroup]="medicineDateRangeForm" class="dashboard-section__filters dashboard-section__filters--wrap">
          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__date-field" subscriptSizing="dynamic">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="medicinePicker">
              <input formControlName="start" matStartDate>
              <input formControlName="end" matEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="medicinePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #medicinePicker></mat-date-range-picker>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__select dashboard-section__select--criteria" subscriptSizing="dynamic">
            <mat-label>Criteria</mat-label>
            <mat-select required data-testid="criteria" formControlName="criteria">
              @for (criteria of criterias; track criteria) {
                <mat-option [value]="criteria.value">{{ criteria.type }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__search" subscriptSizing="dynamic">
            <mat-label>Individual</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input
              type="text"
              aria-label="Search for an individual"
              matInput
              formControlName="doctorName"
              [matAutocomplete]="auto">
            <mat-autocomplete (optionSelected)="doctorSelected($event)" autoActiveFirstOption #auto="matAutocomplete">
              @for (doctor of doctors; track doctor) {
                <mat-option [value]="doctor">{{ doctor.first_name + ' ' + doctor.last_name }}</mat-option>
              }
            </mat-autocomplete>
            @if (selectedDoctor) {
              <button type="button" (click)="deselectDoctor()" mat-icon-button matSuffix aria-label="Remove individual">
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__search" subscriptSizing="dynamic">
            <mat-label>Company</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input
              type="text"
              aria-label="Search for a company"
              matInput
              formControlName="companyName"
              [matAutocomplete]="companyAuto">
            <mat-autocomplete (optionSelected)="companySelected($event)" autoActiveFirstOption #companyAuto="matAutocomplete">
              @for (company of companies; track company) {
                <mat-option [value]="company">{{ company.name }}</mat-option>
              }
            </mat-autocomplete>
            @if (selectedCompany) {
              <button type="button" (click)="deselectCompany()" mat-icon-button matSuffix aria-label="Remove company">
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-form-field>
        </form>

        <core-medicine-report
          [data]="medicineReportData"
          [config]="medicineReportConfig"
          [heading]="'Medicine report'">
        </core-medicine-report>

        @if (perm.canMutateDashboard()) {
          <div class="dashboard-section__actions">
            <div class="dashboard-section__action-row">
            <mat-form-field appearance="outline" class="dashboard-section__select dashboard-section__select--action" subscriptSizing="dynamic">
              <mat-select
                id="dashboard-medicine-report-type"
                placeholder="Report type"
                aria-label="Report type"
                [formControl]="downloadMedicineReportControl">
                <mat-option value="csv">CSV</mat-option>
                <mat-option value="excel">Excel</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              type="button"
              class="dashboard-section__btn"
              [disabled]="downloadMedicineReportControl.invalid"
              mat-stroked-button
              (click)="generateAndDownloadMedicine()">
              <mat-icon>file_download</mat-icon> Download
            </button>
            </div>
          </div>
        }
      </mat-card>

      <mat-card class="dashboard-section">
        <div class="dashboard-section__header">
          <h2 class="dashboard-section__title">Deliveries</h2>
        </div>

        <form [formGroup]="deliveryReportDataForm" class="dashboard-section__filters dashboard-section__filters--wrap">
          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__date-field" subscriptSizing="dynamic">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="diffPicker">
              <input formControlName="start" matStartDate>
              <input formControlName="end" matEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="diffPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #diffPicker></mat-date-range-picker>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__search" subscriptSizing="dynamic">
            <mat-label>Distributor</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input
              type="text"
              aria-label="Search for a distributor"
              matInput
              formControlName="distributorName"
              [matAutocomplete]="distributorAuto">
            <mat-autocomplete (optionSelected)="distributorSelected($event)" autoActiveFirstOption #distributorAuto="matAutocomplete">
              @for (distributor of distributors; track distributor) {
                <mat-option [value]="distributor">{{ distributor.name }}</mat-option>
              }
            </mat-autocomplete>
            @if (selectedDistributor) {
              <button type="button" (click)="deselectDistributor()" mat-icon-button matSuffix aria-label="Remove distributor">
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-form-field>
        </form>

        @if (perm.canMutateDashboard()) {
          <div class="dashboard-section__actions">
            <div class="dashboard-section__action-row">
            <mat-form-field appearance="outline" class="dashboard-section__select dashboard-section__select--action" subscriptSizing="dynamic">
              <mat-select
                id="dashboard-deliveries-report-type"
                placeholder="Report type"
                aria-label="Report type"
                [formControl]="downloadDelReportControl">
                <mat-option value="csv">CSV</mat-option>
                <mat-option value="excel">Excel</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              type="button"
              class="dashboard-section__btn"
              [disabled]="downloadDelReportControl.invalid || deliveryReportDataForm.invalid"
              mat-stroked-button
              (click)="generateAndDownloadDelivery()">
              <mat-icon>file_download</mat-icon> Download
            </button>
            </div>
          </div>
        }
      </mat-card>

      <mat-card class="dashboard-section">
        <div class="dashboard-section__header">
          <h2 class="dashboard-section__title">Vetscripts daily shipped report</h2>
        </div>
        <p class="dashboard-section__help">
          Generate a CSV of Vetscripts orders that shipped on a chosen date. Leave date empty for today (UTC).
          The scheduled report also runs daily at 5pm SAST and is sent by email.
        </p>
        <div class="dashboard-section__filters">
          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__date-field dashboard-section__date-field--single" subscriptSizing="dynamic">
            <mat-label>Report date (optional)</mat-label>
            <input matInput [matDatepicker]="vetscriptsDatePicker" [formControl]="vetscriptsReportDateControl">
            <mat-datepicker-toggle matSuffix [for]="vetscriptsDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #vetscriptsDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        @if (perm.canMutateDashboard()) {
          <div class="dashboard-section__actions dashboard-section__actions--start">
            <button
              type="button"
              class="dashboard-section__btn"
              mat-stroked-button
              [disabled]="vetscriptsReportLoading"
              (click)="generateVetscriptsShippedReport()">
              @if (!vetscriptsReportLoading) {
                <mat-icon>file_download</mat-icon>
              }
              @if (vetscriptsReportLoading) {
                <mat-spinner diameter="20"></mat-spinner>
              }
              {{ vetscriptsReportLoading ? 'Generating…' : 'Download report' }}
            </button>
          </div>
        }
      </mat-card>

      <mat-card class="dashboard-section">
        <div class="dashboard-section__header">
          <h2 class="dashboard-section__title">Split orders report</h2>
        </div>
        <p class="dashboard-section__help">
          Download split orders (parent/child) as CSV or Excel. Optional filters: order placed date range and distributor.
          Leave empty for all split orders.
        </p>
        <form [formGroup]="splitOrdersDateRangeForm" class="dashboard-section__filters dashboard-section__filters--wrap">
          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__date-field" subscriptSizing="dynamic">
            <mat-label>Date range (optional)</mat-label>
            <mat-date-range-input [rangePicker]="splitOrdersPicker">
              <input formControlName="start" matStartDate>
              <input formControlName="end" matEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="splitOrdersPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #splitOrdersPicker></mat-date-range-picker>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="dashboard-section__search" subscriptSizing="dynamic">
            <mat-label>Distributor</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              aria-label="Search distributor"
              [formControl]="splitOrdersDistributorName"
              [matAutocomplete]="splitOrdersDistributorAuto">
            <mat-autocomplete #splitOrdersDistributorAuto="matAutocomplete" (optionSelected)="splitDistributorSelected($event)" autoActiveFirstOption>
              @for (c of splitOrdersDistributors; track c) {
                <mat-option [value]="c">{{ c.name }}</mat-option>
              }
            </mat-autocomplete>
            @if (selectedSplitDistributor) {
              <button type="button" mat-icon-button matSuffix (click)="deselectSplitDistributor()" aria-label="Clear distributor">
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-form-field>
        </form>
        @if (perm.canMutateDashboard()) {
          <div class="dashboard-section__actions dashboard-section__actions--start">
            <div class="dashboard-section__action-row">
            <mat-form-field appearance="outline" class="dashboard-section__select dashboard-section__select--action" subscriptSizing="dynamic">
              <mat-select
                id="dashboard-split-orders-report-type"
                placeholder="Report type"
                aria-label="Report type"
                [formControl]="downloadSplitOrdersReportControl">
                <mat-option value="csv">CSV</mat-option>
                <mat-option value="excel">Excel</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              type="button"
              class="dashboard-section__btn"
              mat-stroked-button
              [disabled]="downloadSplitOrdersReportControl.invalid || splitOrdersDownloadLoading"
              (click)="generateAndDownloadSplitOrders()">
              @if (!splitOrdersDownloadLoading) {
                <mat-icon>file_download</mat-icon>
              }
              @if (splitOrdersDownloadLoading) {
                <mat-spinner diameter="20"></mat-spinner>
              }
              {{ splitOrdersDownloadLoading ? 'Downloading…' : 'Download' }}
            </button>
            </div>
          </div>
        }
      </mat-card>
    </div>
  </div>
</div>
